/**
 * Supabase client initialization
 * Used for auth only (sign in, sign out, token management).
 *
 * URL + anon key come from Vite env (frontend/.env). The anon key is public by
 * design and safe to ship in the browser bundle; the service-role key must never
 * appear here.
 */

import { createClient } from '@supabase/supabase-js';

// Read from Vite env so production (Vercel) points at the production project.
// Falls back to the dev project literals so local `vite dev` works with no .env.
const supabaseUrl =
  import.meta.env.VITE_SUPABASE_URL || 'https://klbzegachtfxgkfihbzc.supabase.co';
const supabaseAnonKey =
  import.meta.env.VITE_SUPABASE_ANON_KEY ||
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtsYnplZ2FjaHRmeGdrZmloYnpjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODI0NzE0MTUsImV4cCI6MjA5ODA0NzQxNX0.uWvSzRfI5Vev9RvP1F-ppJ_jU4gfcj7UbPQaC_AeV2w';

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. Copy frontend/.env.example to frontend/.env and fill them in.'
  );
}

export const supabaseClient = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    // We persist the token ourselves in sessionStorage via AuthContext, but
    // letting supabase-js manage its own session enables silent token refresh
    // (refreshSession) when AuthContext asks for a new access token.
    persistSession: true,
    autoRefreshToken: true,
    // Parse the token from invite / password-recovery links (URL hash) so the
    // AuthSetup page has a session to authenticate updateUser({ password }).
    detectSessionInUrl: true,
  },
});
